import { OrderBy, OrderDirection } from "@/actions/schemas/products";

export type OrderOptionValue =
  | ""
  | "menor-preco"
  | "maior-preco"
  | "mais-recentes"
  | "mais-antigos";

export type OrderOption = {
  label: string;
  value: OrderOptionValue;
  orderBy: OrderBy;
  orderDirection: OrderDirection;
};

export const ORDER_OPTIONS: OrderOption[] = [
  {
    label: "Alfabética (padrão)",
    value: "" as const,
    orderBy: OrderBy.Name,
    orderDirection: OrderDirection.Asc,
  },
  {
    label: "Menor preço",
    value: "menor-preco" as const,
    orderBy: OrderBy.SalePrice,
    orderDirection: OrderDirection.Asc,
  },
  {
    label: "Maior preço",
    value: "maior-preco" as const,
    orderBy: OrderBy.SalePrice,
    orderDirection: OrderDirection.Desc,
  },
  {
    label: "Mais recentes",
    value: "mais-recentes" as const,
    orderBy: OrderBy.CreatedAt,
    orderDirection: OrderDirection.Desc,
  },
  {
    label: "Mais antigos",
    value: "mais-antigos" as const,
    orderBy: OrderBy.CreatedAt,
    orderDirection: OrderDirection.Asc,
  },
];
